import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import { Button, Box, Typography, Divider } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { useLocation } from 'react-router-dom';

const SocialSignIn = () => {
  const location = useLocation();
  const [redirecting, setRedirecting] = useState(false);

  const isRegisterPage = location.pathname === '/register';
  const buttonText = isRegisterPage ? 'Sign up with Google' : 'Sign in with Google';

  const signInWithGoogle = () => {
    setRedirecting(true);
    Auth.federatedSignIn({ provider: 'Google' }).catch(err => {
      console.error("federatedSignIn error:", err);
      setRedirecting(false);
    });
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Divider sx={{ my: 2 }}>
        <Typography variant="body2" color="text.secondary">
          OR CONTINUE WITH
        </Typography>
      </Divider>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
        <Button
          variant="outlined"
          fullWidth
          startIcon={<GoogleIcon />}
          onClick={signInWithGoogle}
          disabled={redirecting}
          sx={{
            borderColor: '#4285F4',
            color: '#4285F4',
            '&:hover': {
              borderColor: '#4285F4',
              backgroundColor: 'rgba(66, 133, 244, 0.04)',
            },
          }}
        >
          {redirecting ? 'Redirecting to Google\u2026' : buttonText}
        </Button>
      </Box>
    </Box>
  );
};

export default SocialSignIn;
